import { makeAutoObservable, runInAction } from 'mobx';
import { getProductId } from '@/infrastructure/product-info';
import { getWebhookProjects, IWebhookProjectInfo } from '@/presentation/pages/defect-manage/api';
import { FIELDS_PRESET } from '../pages/defect-manage/protocol';

export class DefectStore {
  webhookProjects: Record<string, IWebhookProjectInfo[]> = {};
  projectList: IWebhookProjectInfo[] = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async getDefectProjectList() {
    // if (this.webhookProjects[getProductId()]) {
    //   this.projectList = this.webhookProjects[getProductId()];
    //   return this.projectList;
    // }
    return await this.loadDefectProjectList();
  }

  async loadDefectProjectList() {
    const res = await getWebhookProjects();
    const webhookProjects: any = {
      ...this.webhookProjects,
      [getProductId()]: res ?? [],
    };
    runInAction(() => {
      this.webhookProjects = webhookProjects;
      this.projectList = webhookProjects[getProductId()];
    });
    return this.projectList;
  }

  get defectList() {
    return this.projectList;
  }

  async getFullDefectList(callbacks: {
    userName: () => string | Promise<string>
    version: () => string | Promise<string>
  }) {
    const { userName, version } = callbacks;  // 如果没有回调函数，则返回原始数据
    if (Object.keys(callbacks).length === 0) return this.projectList;

    // 预先获取所有异步值
    const [userNameValue, versionValue] = await Promise.all([
      userName(),
      version(),
    ]);
    return this.defectList.map((project) => {
      if (!project) return project;
      return {
        ...project,
        data: project.data?.map((item) => {
          // 如果没有协议项，则返回原始数据
          const protocolItem = FIELDS_PRESET.find(field => field.fieldName === item.name);
          if (!protocolItem) return item;
          // 获取值的占位符
          const valuePlace = protocolItem.defaultValue?.match(/\${(.*?)}/)?.[1];
          if (!valuePlace) return item;
          let { value } = item;
          // 替换值的占位符
          if (valuePlace === 'userName') value =  protocolItem.defaultValue?.replace('${userName}', userNameValue);
          if (valuePlace === 'version') value = protocolItem.defaultValue?.replace('${version}', versionValue);
          // 返回替换后的数据
          return {
            ...item,
            value,
          };
        }),
      };
    });
  }
}
